
(() => {

    const BODY = document.body
    const TRIGGER = BODY.querySelector('.header-mobile .hamburger')
    const SEARCH_TRIGGER = BODY.querySelector('.header-mobile--search-trigger')
    const NAVIGATION = BODY.querySelector('.header-mobile--navigation')

    if(!TRIGGER || !SEARCH_TRIGGER || !NAVIGATION) return false

    function toggleMenu() {
        BODY.classList.toggle('mobile-active')
    }

    TRIGGER.addEventListener('click', toggleMenu)

    SEARCH_TRIGGER.addEventListener('click', () => {

        if(Array.from(BODY.classList).indexOf('mobile-active') === -1) {
            toggleMenu()
        }

        NAVIGATION.querySelector('input').focus()
    })

})()
